// extracted by mini-css-extract-plugin
module.exports = {"content":"NavbarWorkspaces_content__3HQGD","workspaces":"NavbarWorkspaces_workspaces__4U-6s","active":"NavbarWorkspaces_active__zejJk","logout":"NavbarWorkspaces_logout__nAcl4"};